import { produce } from "immer";

const chatReducer = (
    state = {
        loading: false,
        loading_update: false,
        orders: null,
        shipments: null,
        currentOrder: null,
        activeTab: "all",
        loading_categories: false,
        categories: [],
        loading_category_collection: false,
        category_collection: [],
    },
    action
) => {
    switch (action.type) {
        case "SET_CURRENT_ORDER":
            state = {
                ...state,
                currentOrder: action.payload,
            };
            break;
        case "GET_ORDERS_REQUEST":
            state = {
                ...state,
                loading: true,
            };
            break;
        case "GET_ORDERS_SUCCESS":
            state = {
                ...state,
                orders: action.payload,
                loading: false,
            };
            break;
        case "GET_ORDERS_FAILURE":
            state = {
                ...state,
                loading: false,
            };
            break;
        case "SET_ACTIVE_TAB":
            state = {
                ...state,
                activeTab: action.payload,
            };
            break;
        case "UPDATE_ORDER_REQUEST":
            state = {
                ...state,
                loading_update: true,
            };
            break;
        case "UPDATE_ORDER_SUCCESS":
            return produce(state, (draft) => {
                draft.loading_update = false;
                draft.currentOrder = action.payload;
                if (draft.orders && action.payload) {
                    const idx = draft.orders.findIndex(
                        (order) => order.order_id === action.payload.order_id
                    );
                    if (idx !== -1) {
                        draft.orders[idx] = action.payload;
                    }
                    if (action.payload.order_id === draft.currentOrder.order_id) {
                        draft.currentOrder = action.payload;
                    }
                }
            });
        case "UPDATE_ORDER_FAILURE":
            state = {
                ...state,
                loading_update: false,
            };
            break;
        case "GET_ORDER_REQUEST":
            state = {
                ...state,
                loading: true,
            };
            break;
        case "GET_ORDER_SUCCESS":
            state = {
                ...state,
                currentOrder: action.payload,
                loading: false,
            };
            break;
        case "GET_ORDER_FAILURE":
            state = {
                ...state,
                loading: false,
            };
            break;
        case "FETCH_ALL_SHIPMENTS_REQUEST":
            state = {
                ...state,
                loading: true,
            };
            break;
        case "FETCH_ALL_SHIPMENTS_SUCCESS":
            const offset = action.payload.offset;

            state = {
                ...state,
                shipments: {
                    ...action.payload,
                    data:
                        offset == 0
                            ? action.payload.data
                            : [
                                ...(state.shipments?.data || []),
                                ...(action.payload.data || []),
                            ],
                },
                loading: false,
            };
            break;
        case "FETCH_ALL_SHIPMENTS_FAILURE":
            state = {
                ...state,
                loading: false,
                error: action.payload,
            };
            break;
        case "FETCH_CATEGORIES_REQUEST":
            state = {
                ...state,
                loading_categories: true,
            };
            break;
        case "FETCH_CATEGORIES_SUCCESS":
            state = {
                ...state,
                loading_categories: false,
                categories: action.payload,
            };
            break;
        case "FETCH_CATEGORIES_FAILURE":
            state = {
                ...state,
                loading_categories: false,
                error: action.payload,
            };
            break;
        case "FETCH_CATEGORY_COLLECTION_REQUEST":
            state = {
                ...state,
                loading_category_collection: true,
            };
            break;
        case "FETCH_CATEGORY_COLLECTION_SUCCESS":
            state = {
                ...state,
                loading_category_collection: false,
                category_collection: action.payload,
            };
            break;
        case "FETCH_CATEGORY_COLLECTION_FAILURE":
            state = {
                ...state,
                loading_category_collection: false,
                error: action.payload,
            };
            break;
        case "FETCH_RECENTLY_PURCHASED_REQUEST":
            state = {
                ...state,
                loading_recently_purchased: true,
            };
            break;
        case "FETCH_RECENTLY_PURCHASED_SUCCESS":
            state = {
                ...state,
                loading_recently_purchased: false,
                recently_purchased: action.payload,
            };
            break;
        case "FETCH_RECENTLY_PURCHASED_FAILURE":
            state = {
                ...state,
                loading_recently_purchased: false,
                error: action.payload,
            };
            break;
    }
    return state;
};

export default chatReducer;
